import { render, staticRenderFns } from "./ATruncate.vue?vue&type=template&id=cd563e38"
import script from "./ATruncate.vue?vue&type=script&lang=js"
export * from "./ATruncate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports